import { ActionIcon, ActionIconProps } from "@mantine/core"
import { forwardRef } from "react"

/**
 * @deprecated - Just use a normal button with the ActionIcon component
 */
interface BlueActionButtonProps extends ActionIconProps {
  onClick?: () => void
  component?: any
  href?: string
  target?: string
}
export const BlueActionButton = forwardRef<HTMLButtonElement, BlueActionButtonProps>(function BlueActionButton({ children, onClick, component, href, target, ...props }, ref) {
  return (
    <ActionIcon ref={ref} size="lg" radius="md" variant="filled" component={component} href={href} target={target} {...props} color="rBackBlue.9" onClick={onClick}>
      {children}
    </ActionIcon>
  )
})
